export default "/42e0abd22c99497d61659d22e9d29665.jpg";